import React from 'react';
import fullscreen from "../../assets/img/icons/fullscreen.svg";
import backArrow from "../../assets/img/icons/blueArrow.svg";
import { Link } from "react-router-dom";

const PublishedDate = ({
    pagename,
    details,
    onChange,
    onSubmitArticle,
    // downloads, 
    // viewCount 
}) => {
    console.log("details :", details)
    const handleClick = (e) => {
        e.preventDefault();
        onChange();
    };
    const isSocietyJournal =
        details?.journalType === "Society Journal" ||
        details?.submissionDetail?.journalType?.journalType === "Society Journal" ||
        details?.journaldstype === "societyArticle" ||
        details?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
        details?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf";

    const isMegaJournal = !isSocietyJournal;

    const doiVal = details?.doiUrl || details?.doi || details?.doiurl;

    const hasContent =
        (details?.publishedDate && details?.status === "published") ||
        details?.volume || details?.volSet?.volume || details?.volSet?.volumenr ||
        details?.issue || details?.volSet?.issue ||
        doiVal ||
        pagename === "viewPublishedArticle" ||
        pagename === "previewArticle" ||
        pagename !== "previewArticle";

    if (!hasContent) {
        return null;
    }

    return (
        <div className="publishedBox stylechange">
            <div className="innerMergin justify-content-between">
                <div className="d-flex fs-16" style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", marginRight: "10px" }}>
                        {details?.publishedDate && <>
                            <span className="theme-orange-color">Published:</span>
                            <div>
                                {pagename === 'previewArticle' || details?.status !== "published" ? "--" : details?.publishedDate}
                            </div>
                        </>}
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        {(details?.volume || details?.volSet?.volume || details?.volSet?.volumenr || details?.issue || details?.volSet?.issue) && <>
                            <span className="theme-orange-color">Volume:</span>
                            <div>
                                {details?.volume || details?.volSet?.volume || details?.volSet?.volumenr || 1}
                            </div>
                        </>}
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        {(details?.volume || details?.volSet?.volume || details?.volSet?.volumenr || details?.issue || details?.volSet?.issue) && <>
                            <span className="ms-3 theme-orange-color">Issue:</span>
                            <div>
                                {details?.issue || details?.volSet?.issue || 1}
                            </div>
                        </>}
                    </div>

                    {doiVal ? (
                        <a className="ms-4" href={doiVal.startsWith("http") ? doiVal : `https://doi.org/${doiVal}`}>
                            {doiVal.startsWith("http") ? doiVal : `https://doi.org/${doiVal}`}
                        </a>
                    ) : (isMegaJournal && pagename !== "previewArticle") ? (
                        <span className="ms-4" style={{ color: "red", fontWeight: "bold" }}>
                            DOI awaited...
                        </span>
                    ) : null}

                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginLeft: "20px" }}>
                        {pagename === "viewPublishedArticle" && (
                            <div className="viewcommentline ml-5">
                                <a className="mr-3" href="#fullscreen" onClick={handleClick}>Read Full Screen <img className="ps-2" src={fullscreen} alt="fullscreen icon" /></a>
                            </div>
                        )}

                    </div>

                    {(() => {
                        const journalName = details?.submissionDetail?.journalName;
                        const discipline = details?.submissionDetail?.disciplineType?.disciplineName || "medicine";

                        // Clean the slug: trim, remove non-alphanumeric, replace spaces with dashes, and remove trailing dashes
                        const journalSlug = journalName?.toLowerCase().trim().replace(/[^a-z0-9\s]/g, "").replace(/\s+/g, "-").replace(/-+$/, "");
                        const disciplineSlug = discipline?.toLowerCase().trim().replace(/[^a-z0-9\s]/g, "").replace(/\s+/g, "-").replace(/-+$/, "");

                        let journalHomeUrl = "/";
                        if (details?.journalType === "Society Journal") {
                            journalHomeUrl = `/society-journals/${disciplineSlug}/${journalSlug}`;
                        } else {
                            if (journalName === "Samaj Shastra – The Mega Journal of Social Sciences") {
                                journalHomeUrl = "/mega-journals/social-sciences";
                            } else if (journalName === "Chanakya Shastra – The Mega Journal of Business and Management") {
                                journalHomeUrl = "/mega-journals/business-management";
                            } else if (journalName === "Charakh Shastra – The Mega Journal of Medicine") {
                                journalHomeUrl = "/mega-journals/medicine";
                            } else if (journalName === "Soochna  Shastra – The Mega Journal of Information Technology") {
                                journalHomeUrl = "/mega-journals/information-technology";
                            } else if (journalName === "Vigyan Shastra – The Mega Journal of Sciences") {
                                journalHomeUrl = "/mega-journals/sciences";
                            } else if (journalName === "Abhiyantran Shastra – The Mega Journal of Engineering") {
                                journalHomeUrl = "/mega-journals/engineering";
                            } else if (journalName === "AyurYoga – The Mega Journal of Ayurveda and Yoga") {
                                journalHomeUrl = "/mega-journals/ayurveda-and-yoga";
                            }
                        }

                        const isSocietyJournal =
                            details?.journalType === "Society Journal" ||
                            details?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                            details?.journalType?.journalType === "Society Journal" ||
                            details?.submissionDetail?.journalType?.journalType === "Society Journal" ||
                            details?.journaldstype === "societyArticle" ||
                            details?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
                            details?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                            Boolean(details?.submissionDetail?.societyName);
                        const isMegaJournal = !isSocietyJournal;
                        const articleId = details?.id || details?._id || window.location.pathname.split("/")[2];

                        return (
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                                {pagename === "previewArticle" && !isMegaJournal && (
                                    <Link
                                        to={`/dashboard/edit-article/${articleId}`}
                                        className="backLink"
                                        style={{
                                            backgroundColor: "#009b94",
                                            borderColor: "#009b94",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px",
                                            whiteSpace: "nowrap",
                                            width: "auto",
                                            minWidth: "max-content",
                                            padding: "0 18px",
                                            height: "42px",
                                            lineHeight: "normal",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            textDecoration: "none"
                                        }}
                                    >
                                        <img src={backArrow} alt="Back" style={{ transform: "rotate(180deg)", filter: "brightness(0) invert(1)", height: "14px" }} />
                                        <span style={{ whiteSpace: "nowrap" }}>Back To Article Editor</span>
                                    </Link>
                                )}
                                {pagename !== "previewArticle" && (
                                    <Link
                                        to={journalHomeUrl}
                                        className="backLink"
                                    >
                                        Journal Homepage
                                    </Link>
                                )}
                            </div>
                        );
                    })()}
                </div>
            </div>
        </div>
    );
};

export default PublishedDate;
